import { AttachmentListController } from './attachment-list.controller'

function attachmentList () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      attachments: '<',
      mActions: '<',
      readOnly: '<',
      slider: '<',
      changeVisibility: '<',
      hideInformation: '<',
      openPreview: '&',
      location: '<'
    },
    templateUrl: '/workflow/directives/attachment-list/attachment-list.html?$$REVISION$$',
    controller: AttachmentListController
  }
}

export { attachmentList }
